import { formatISO } from 'date-fns';
import { useTranslation } from 'next-i18next';
import React, { useContext } from 'react';

import { WorkerDetailedCard } from '@/modules/workingDayReconciliation';
import { Day, Summary } from '@/modules/workingDayReconciliation';
import { useGetWorkerDailyDuesSummary } from '@/modules/workingDayReconciliation/apiHooks';
import { WorkingDayReconciliationContext } from '@/modules/workingDayReconciliation/context/context';
import { Loading } from '@/shared/components/atoms';
import { EmptyCard } from '@/shared/components/molecules';
import { useStore } from '@/shared/hooks/context/createGenericContext';

const WorkerDailyDuesSummary = () => {
  const {
    state: { startDate, endDate, workerId },
  } = useContext(WorkingDayReconciliationContext);
  const { t } = useTranslation('common');
  const [selectedAsset] = useStore((store) => store?.asset);

  const { data, isLoading } = useGetWorkerDailyDuesSummary({
    entityId: selectedAsset?.id,
    startDate: startDate
      ? formatISO(startDate, { representation: 'date' })
      : '',
    endDate: endDate ? formatISO(endDate, { representation: 'date' }) : '',
    workerId,
  });

  if ((data?.dates.length === 0 && !isLoading) || !data) {
    return <EmptyCard message={t('no-jobs')} variant='text' />;
  }
  if (isLoading) {
    return <Loading />;
  }
  return (
    <div className='flex flex-col gap-y-16 pb-16'>
      <Summary {...data?.summary} />
      {data?.dates.map((item, idx) => (
        <Day key={item.date} date={new Date(item.date)} defaultOpen={idx === 0}>
          <WorkerDetailedCard date={new Date(item.date)} />
        </Day>
      ))}
    </div>
  );
};
export { WorkerDailyDuesSummary };
